// src/pages/VerifyPage.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { firestore, collection, query, where, getDocs } from '../firebase-config';
import './VerifyPage.css';

const VerifyPage = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { verifyPlayer, isVerified, verifiedPlayer } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Query Firestore for a player with this verify code
      const playersRef = collection(firestore, 'players');
      const q = query(playersRef, where('verifyCode', '==', code.toUpperCase()));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError('Invalid code. Please check and try again.');
        setLoading(false);
        return;
      }

      // Get the first matching player (should only be one)
      const playerDoc = querySnapshot.docs[0];
      const playerData = playerDoc.data();
      const playerUuid = playerDoc.id;

      // Check if code has expired
      const now = Date.now();
      if (playerData.verifyCodeExpiry && playerData.verifyCodeExpiry < now) {
        setError('Code has expired. Please run /verify in-game again.');
        setLoading(false);
        return;
      }

      // Verify successful - store UUID
      verifyPlayer(playerUuid);
      
      // Navigate to their profile
      navigate(`/player/${playerData.playerId}/profile`);
    } catch (err) {
      console.error('Verification error:', err);
      setError('An error occurred. Please try again.');
      setLoading(false);
    }
  };

  if (isVerified) {
    return (
      <div className="container verify-page">
        <div className="card verify-card">
          <h2>Already Verified ✓</h2>
          <p>You're logged in as <strong>{verifiedPlayer.username}</strong></p>
          <button onClick={() => navigate(`/player/${verifiedPlayer.playerId}/profile`)}>
            View Profile
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container verify-page">
      <div className="card verify-card">
        <h2>Verify Your Minecraft Account</h2>
        <p>Link your browser to your in-game account to access your profile and chat.</p>
        
        <div className="verify-steps">
          <div className="step">
            <span className="step-number">1</span>
            <p>Join the server at <strong>canvasmc.net</strong></p>
          </div>
          <div className="step">
            <span className="step-number">2</span>
            <p>Run the command <code>/verify</code> in-game</p>
          </div>
          <div className="step">
            <span className="step-number">3</span>
            <p>Enter the code you receive below</p>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter your 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={6}
            disabled={loading}
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" disabled={loading || code.length < 6}>
            {loading ? 'Verifying...' : 'Verify Account'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyPage;